window.downloadFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
};
